export default {"src":"/_next/static/media/improved-safety-security.500764af.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};